import { autoCompleteFormatField } from 'components/AutoCompleteContainer/AutoCompleteContainer.utils';
import { fetchPost, objectify, objectifyAddress, fetchGet } from '../utils';
import moment from 'moment';

export const search = (query) => {
  const { SearchText, Sort, BatchPage, Filters } = query;
  let filters = {};
  if (Filters) {
    const { FromDate, ToDate, CustomerId, DocumentType, ...rest } = Filters;
    filters = {
      ...rest,
      FromDate: Filters.FromDate && moment(Filters.FromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ToDate: Filters.ToDate && moment(Filters.ToDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      CustomerId: Filters.CustomerId ? Number(Filters.CustomerId) : undefined,
      ...autoCompleteFormatField(DocumentType, { fieldName: "DocumentType", specialCases: { al: "" } }),
    };
  }

  const respType = 'Inline'
  return fetchPost('/SalesInvoiceEnquiry/SearchInvoices', { SearchText, Sort, BatchPage, ...filters }, null, respType)
    .then((result) => (result && result.SalesInvoices && {
      invoices: result.SalesInvoices.map((val) => ({ ...objectify(val), key: `${val.SalesEntity.Value}-${val.Invoice.Value}` })),
      currPage: result.BatchInformation && result.BatchInformation.BatchPage,
      nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
      prevPage: result.BatchInformation && result.BatchInformation.BatchPage > 1,
    }) || { invoices: [] })
}

export const searchById = ({ SalesEntity, InvoiceNumber }) => {
  return fetchGet(`/SalesInvoiceEnquiry/SalesInvoice/${InvoiceNumber}/Entity/${SalesEntity}/DocumentDetails`, null, 'Inline')
    .then((result) => ({
      invoices: (
        result?.DocumentDetails
        && [
          {
            ...objectify({ ...result.DocumentDetails, Customer: result.DocumentDetails?.CustomerId, CustomerPO: result.DocumentDetails?.CustomerPurchaseOrder, Invoice: result.DocumentDetails?.InvoiceNumber }), key: `${result.DocumentDetails.SalesEntity.Value}-${result.DocumentDetails.InvoiceNumber.Value}`
          }
        ]
      )
        || [],
      currPage: 1,
      nextPage: false,
      prevPage: false
    }));
}

export const getSummary = (query) => {
  const { InvoiceNumber, SalesEntity } = query
  const respType = 'Inline'
  return fetchGet(`/SalesInvoiceEnquiry/SalesInvoice/${InvoiceNumber}/Entity/${SalesEntity}/DocumentDetails`, null, respType)
    .then((result) => (result && { ...result.DocumentDetails }))
}

export const getDetails = (query) => {
  const { InvoiceNumber, SalesEntity } = query
  const respType = 'Inline'
  return fetchGet(`/SalesInvoiceEnquiry/SalesInvoice/${InvoiceNumber}/Entity/${SalesEntity}`, null, respType)
    .then((result) => {
      const objectified = objectify(result.SalesInvoice);
      return ({
        schema: result.SalesInvoice, values: { ...objectified, address: objectifyAddress(objectified, 'Postal') }
      })
    })
}
